import React, {
	createContext,
	useContext,
	useEffect,
	// useEffect,
	useMemo
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import Loader from '../components/Loader';
import { getSiteConfig } from '../containers/SiteConfig/siteConfigSlice';

const SiteConfigContext = createContext();

const SiteConfigContextProvider = ({ children }) => {
	/* ====================== HOOKS ====================== */
	const dispatch = useDispatch();
	const {
		data: config,
		error,
		isLoading,
		hasBeenLoaded
	} = useSelector((state) => state.siteConfigSlice);

	/* ====================== VALIDATOR ====================== */
	/* ====================== EFFECTS ====================== */
	useEffect(() => {
		if (!hasBeenLoaded) {
			dispatch(getSiteConfig());
		}
	}, []);

	/* ====================== METHODS ====================== */

	/* ====================== MEMO ====================== */
	const value = useMemo(
		() => ({
			siteConfig: config
		}),
		[config]
	);

	/* ====================== RENDER ====================== */
	if (error) {
		return <p>Site Load Error: {error}</p>; // @TODO: Write the main error page.
	}

	if (isLoading || !hasBeenLoaded) {
		return <Loader />;
	}

	if (config.mode === 'maintenance') {
		return <p>Maintenance Mode</p>; // @TODO: Write the maintenance mode page.
	}

	return (
		<SiteConfigContext.Provider value={value}>
			{children}
		</SiteConfigContext.Provider>
	);
};

SiteConfigContextProvider.propTypes = {
	children: PropTypes.object
};

export const SiteConfigProvider = withTranslation()(SiteConfigContextProvider);

export const useSiteConfig = () => {
	return useContext(SiteConfigContext);
};
